exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card[data-v-33b6cc70] table > tbody > tr > td {\n\tcursor: pointer;\n}\n", ""]);

// exports
